import React, { Component } from "react";
import OverviewView from "./OverviewViewv3";
import { FEATURES } from "../util/Constants";
import CycleFilterContextProvider from "./context/CycleFilterContext";
import PVAOverviewContextProvider from "./context/PVAOverviewContext";
import OverviewContextProvider from "./context/OverviewContext";
import CapabilityContextProvider from "./context/CapabilityContext";
import {
  getOpsClockEventsAndBreaks,
  getSettingsInsights,
} from "./network/OverviewNetworkAPI";
import { getDispatchDate } from "./utils/utils";
import { getFeatureStatus } from "../handler/ParentDataHandler";
import PVAView from "./PVAViewv3";

class Overviewv3 extends Component {
  constructor() {
    super();
    this.state = {
      breaksDataSources: {
        settingsInsights: {},
        opsClockData: {},
        isLMOCSEnabledForOpsClockData: false,
      },
    };
    this.dispatchDate = new Date().toISOString().substring(0, 10);
  }

  componentDidMount() {
    this.fetchSettingsInsights();
  }

  fetchSettingsInsights = () => {
    getSettingsInsights()
      .then((settingsInsights) => {
        this.setState({
          breaksDataSources: {
            ...this.state.breaksDataSources,
            settingsInsights,
          },
        });
        this.dispatchDate = getDispatchDate(settingsInsights);
      })
      .catch(() => false)
      .finally(() => {
        this.fetchIsLMOCSEnabledForOpsClockDataFeatureFlag();
      });
  };

  fetchIsLMOCSEnabledForOpsClockDataFeatureFlag = () => {
    getFeatureStatus([FEATURES.IS_LMOCS_ENABLED_FOR_OPS_CLOCK_DATA]).then(
      (res) => {
        if (res.data && res.data.isLMOCSEnabledForOpsClockData) {
          this.setState({
            breaksDataSources: {
              ...this.state.breaksDataSources,
              isLMOCSEnabledForOpsClockData: true,
            },
          });
          this.fetchOpsClockEventsAndBreaks();
        }
      },
    );
  };

  fetchOpsClockEventsAndBreaks = () => {
    getOpsClockEventsAndBreaks(this.dispatchDate)
      .then((opsClockData) => {
        this.setState({
          breaksDataSources: {
            ...this.state.breaksDataSources,
            opsClockData,
          },
        });
      })
      .catch(() => false);
  };

  render() {
    return (
      <CapabilityContextProvider>
        <CycleFilterContextProvider>
          <PVAOverviewContextProvider>
            <OverviewContextProvider>
              <OverviewView
                breaksDataSources={this.state.breaksDataSources}
                pva={{ processName: "inbound" }}
              />
            </OverviewContextProvider>
            <PVAView
              pva={{ processName: "inbound" }}
              breaksDataSources={this.state.breaksDataSources}
            />
          </PVAOverviewContextProvider>
        </CycleFilterContextProvider>
      </CapabilityContextProvider>
    );
  }
}

export default Overviewv3;



// WEBPACK FOOTER //
// ./src/components/overview/Overviewv3.js